import React, { useState, useEffect,useRef } from 'react'

import { useHistory } from "react-router-dom";

import { Pie,measureTextWidth } from '@ant-design/plots';
import {numberWithCommas} from '../../../utils/helpers'
import { Table, Tooltip,Tag, Input, Button, Space,message} from 'antd';
import {   
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    UserOutlined,
    VideoCameraOutlined,
    UploadOutlined, 
    DeploymentUnitOutlined,
    SearchOutlined
} from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import './styles.scss';

import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import moment from 'moment'



const Index = ({currentData,angleField,colorField,onSelectedCategories, onCurrentSelectedCategory}) => {

  const dispatch = useDispatch()   

  const {  } = useSelector(
    state => ({
 
 
    }),
    shallowEqual
  )
  const Chartref = useRef()  

    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [dataTotal, setDataTotal] = useState(0)

    const [selectedCategories, setSelectedCategories] = useState([])
    const [currentSelectedCategory, setCurrentSelectedCategory] = useState(null)


    
    useEffect(() => {
      if(currentData){
        var newDatum  = currentData.sort((a, b) => a[angleField]-b[angleField])
        var total = 0
        newDatum.map(it=>{
          total += it[angleField]
        })
        setDataTotal(total)
        setData(newDatum)
      }
      
      // console.log(currentData)
    },[currentData]);

    useEffect(() => {
      if(onSelectedCategories){

        onSelectedCategories(selectedCategories)
      }

      
    },[selectedCategories]);
        
    useEffect(() => {
      if(onCurrentSelectedCategory){
        onCurrentSelectedCategory(currentSelectedCategory)
      }
 
    },[currentSelectedCategory]);


    const somethingSelected = (currentcat) =>{
     
        var exists = false
        var new_cats = []

  
        selectedCategories.map(cat =>{
    
          // if(cat.id == currentcat.id){
          //   exists = true
     
          // }else{
           
          // }
          // new_cats.push(cat)
        })

    
        if(exists){
          setCurrentSelectedCategory(null)

        }else{
          new_cats.push(currentcat)
          setCurrentSelectedCategory(currentcat)
        }
        console.log(new_cats)
        setSelectedCategories(new_cats)
    }


    
  
    const pesoDisplay =['revenue','cost','sell_price']


    function renderStatistic(containerWidth, text, style) {
      const { width: textWidth, height: textHeight } = measureTextWidth(text, style);
      const R = containerWidth / 2; // r^2 = (w / 2)^2 + (h - offsetY)^2
  
      let scale = 1;
  
      if (containerWidth < textWidth) {
        scale = Math.min(Math.sqrt(Math.abs(Math.pow(R, 2) / (Math.pow(textWidth / 2, 2) + Math.pow(textHeight, 2)))), 1);
      }
  
      const textStyleStr = `width:${containerWidth}px;`;
      return `<div style="${textStyleStr};font-size:${scale}em;line-height:${scale < 1 ? 1 : 'inherit'};">${text}</div>`;
    }
    
    return(
      <div className="mainpie_container">
        <h1>{colorField} - {angleField} </h1>
        
         <Pie 
          ref={Chartref}

          data={data}
          meta={{
            [angleField]:{
              formatter: (v) => `${(pesoDisplay.includes(angleField) ? '₱': '')} ${v ? numberWithCommas(v.toFixed(2)):'none'}`
            }}
          }
         
          label={
           { type: 'inner',
          
            style: {
              textAlign: 'center',
            },
            autoRotate: false,
            content:''
            
          }}

          // tooltip={{
          //   customContent: (title, data) => {
          //     return (`<div>${title}</div>`);
          //   }
          // }}

          // statistic={{            
          //   title: {
          //     offsetY: -4,
          //     customHtml: (container, view, datum) => {
          //       const { width, height } = container.getBoundingClientRect();
          //       const d = Math.sqrt(Math.pow(width / 2, 2) + Math.pow(height / 2, 2));
          //       const text = datum ? datum.type : '总计';
          //         return renderStatistic(d, text, {
          //           fontSize: 28,
          //         });
          //     },
          //   },
          //   content: {
          //     offsetY: 4,
          //     style: {
          //       fontSize: '32px',
          //     },
          //     customHtml: (container, view, datum, data) => {
          //       const { width } = container.getBoundingClientRect();
          //       const text = datum ? `¥ ${datum.value}` : `¥ ${data.reduce((r, d) => r + d.value, 0)}`;
          //       return renderStatistic(width, text, {
          //         fontSize: 32,
          //       });
          //     },
          //   },
          // }}
  
          
   
          isPercent={true}
          radius={1}
          innerRadius={0.7}
          angleField={angleField}
          colorField={colorField}
          interactions={[{ type: 'element-selected' }, { type: 'element-active' },
          { type: 'pie-statistic-active' }
          ]}

          onReady={(plot) => {
            plot.on('element:click', (...args) => {
              var eventres = {...args}
              // console.log(eventres[0].data.data)
        
              somethingSelected(eventres[0].data.data)
              
            })

          //   plot.on('element:mouseover', (...args) => {
          //     console.log(...args);

          //     console.log(plot);
          //   })
         
            
          }}
     
      ></Pie>

      </div>
     
  
      
    )
}
  
export default Index
  